import React from 'react';
import { CopyButton } from './CopyButton';

/**
 * An operation's trace: a link to its logs in Grafana (`logsUrl`, built by viewer-api) with the trace id shortened,
 * and a copy of the full id. Only the id when there is no link; nothing when neither is known.
 */
export function TraceLink({
  traceId,
  logsUrl,
}: {
  traceId?: string | null;
  logsUrl?: string | null;
}) {
  if (!traceId && !logsUrl) {
    return null;
  }
  const short = traceId?.slice(0, 8);
  return (
    <span className="inline-flex items-center gap-2 text-sm">
      {logsUrl ? (
        <a
          href={logsUrl}
          target="_blank"
          rel="noopener noreferrer"
          title={traceId ? `Logs of trace ${traceId}` : 'Logs'}
          className="text-dl-accent hover:underline"
        >
          Logs
          {short && (
            <span className="ml-1 font-mono text-dl-muted">{short}</span>
          )}
        </a>
      ) : (
        <span title={traceId ?? undefined} className="font-mono text-dl-muted">
          {short}
        </span>
      )}
      {traceId && <CopyButton text={traceId} label="Copy the trace id" />}
    </span>
  );
}
